// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"77677a57","527":"8d3c902b","691":"cbbe97ed","743":"1a53f9f8","990":"b1f5179d"}[chunkId] + ".chunk.js";
};